export class GetAllUserRegistrationsRequest {
    CompanyEventId: number;
    constructor(companyEventId: number) {
        this.CompanyEventId = companyEventId;
    }
}
